import React from 'react';
import Header from 'components/ui/Header';
import Footer from 'pages/landing-page/components/Footer';

const FaqPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="w-full" style={{ paddingTop: 'var(--header-height)' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              FAQ – Volaptic
            </h1>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm p-8">
            <div className="prose prose-lg max-w-none text-gray-700">

              <h2>PER I CLIENTI</h2>

              <h3>1. Come funziona la piattaforma?</h3>
              <p>
                Puoi inviare la tua richiesta di servizio. I professionisti registrati ti invieranno preventivi.
                Accetti quello che preferisci e puoi pagare direttamente tramite i nostri partner di pagamento,
                anche a rate.
              </p>

              <h3>2. La piattaforma fornisce direttamente il servizio?</h3>
              <p>
                No. La piattaforma mette in contatto utenti e professionisti.
                Il servizio viene erogato esclusivamente dal professionista scelto.
              </p>

              <h3>3. Posso pagare a rate?</h3>
              <p>
                Sì, attraverso fornitori di pagamento esterni (es. Klarna o altri partner).
                La Piattaforma non concede finanziamenti, non valuta il merito creditizio
                e non è parte del contratto di pagamento.
              </p>

              <h3>4. Cosa succede se il professionista non esegue il lavoro?</h3>
              <p>
                Qualsiasi controversia sull’esecuzione del servizio va risolta direttamente con il professionista.
                La Piattaforma non è responsabile dell’esecuzione o della qualità del servizio.
              </p>

              <h3>5. Quanto costa usare la piattaforma?</h3>
              <p>
                La registrazione e la ricerca dei preventivi sono gratuite.
                La Piattaforma trattiene una percentuale sul valore del lavoro concluso tramite il servizio.
              </p>

              <h3>6. I miei dati sono al sicuro?</h3>
              <p>
                Sì. Tutti i dati sono trattati secondo la nostra Privacy Policy,
                in conformità al GDPR. I pagamenti sono gestiti dai partner di pagamento,
                quindi non trattiamo dati bancari sensibili.
              </p>

              <hr />

              <h2>PER I PROFESSIONISTI</h2>

              <h3>1. Come posso ricevere clienti?</h3>
              <p>
                Registrati, completa il tuo profilo e rispondi ai preventivi richiesti dagli utenti.
              </p>

              <h3>2. Come funziona la percentuale sul lavoro?</h3>
              <p>
                La Piattaforma trattiene una percentuale sul valore del lavoro accettato tramite il sistema.
                La percentuale è indicata prima della conferma del preventivo.
              </p>

              <h3>3. Devo pagare abbonamenti o commissioni extra?</h3>
              <p>
                No. Nessun costo fisso. Paghi solo la percentuale sul lavoro completato tramite la piattaforma.
              </p>

              <h3>4. Chi è responsabile dell’esecuzione del servizio?</h3>
              <p>
                Il Professionista. Tutte le responsabilità legate alla qualità,
                ai tempi e alla fatturazione ricadono sul professionista stesso.
              </p>

              <h3>5. Posso offrire pagamenti rateali?</h3>
              <p>
                Puoi indicare che accetti pagamenti tramite i partner di rateizzazione.
                La gestione del pagamento è tra il cliente e il fornitore esterno,
                non tra te e la piattaforma.
              </p>

              <hr />

              <h2>DOMANDE COMUNI</h2>

              <h3>1. Cos’è il ruolo della piattaforma?</h3>
              <p>
                Siamo un marketplace digitale: facilitatori,
                non fornitori del servizio e non intermediari di credito.
              </p>

              <h3>2. Cosa fare se ho un problema con un pagamento rateale?</h3>
              <p>
                Contatta direttamente il fornitore del pagamento (es. Klarna).
                La Piattaforma non può intervenire sulle rate o sull’approvazione del credito.
              </p>

              <h3>3. Posso cancellare il mio account?</h3>
              <p>
                Sì, puoi richiedere la cancellazione dei dati e dell’account
                secondo quanto previsto nella Privacy Policy.
              </p>

              <h3>4. La piattaforma invia pubblicità o newsletter?</h3>
              <p>
                Solo se hai dato il consenso. Puoi disattivare le comunicazioni marketing in qualsiasi momento.
              </p>

              <h3>5. Come posso contattare la piattaforma?</h3>
              <p>
                Email: volapticpro@gmail.com<br />
                Rispondiamo entro 48 ore lavorative.
              </p>

            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FaqPage;
